import React, { CSSProperties, FC, useEffect } from 'react'

import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'

import cn from 'classnames'

import { restore_account } from '../../utils'

import { useStore } from 'store'

import Footer from '../Footer'
import Header from '../Header'

import styles from './styles.module.scss'

interface IProps {
  headerPositionSticky?: boolean
  headerTransparent?: boolean
  // headerDarkTheme?: boolean
  // headerLightTheme?: boolean
  // headerLinkColor?: string
  headerWithDrawerMenu?: boolean
  withFooter?: boolean
  containerStyle?: CSSProperties
  innerContainerStyle?: CSSProperties
  children?: React.ReactNode
  withHeader?: boolean
  withoutPadding?: boolean
}

export const AppContainer: FC<IProps> = observer(
  ({
    children,
    headerPositionSticky,
    headerTransparent,
    // headerDarkTheme,
    // headerLightTheme,
    // headerLinkColor,
    headerWithDrawerMenu,
    withFooter,
    containerStyle,
    innerContainerStyle,
    withHeader = true,
  }) => {
    const { theme, profile } = useStore()

    const navigate = useNavigate()

    useEffect(() => {
      if (profile?.selectedUser?.DeletionMark) {
        navigate(restore_account())
      }
    }, [profile?.selectedUser?.DeletionMark])

    return (
      <>
        {withHeader && (
          <Header
            positionSticky={headerPositionSticky}
            darkTheme={theme.theme === 'dark'}
            lightTheme={theme.theme === 'light'}
            transparent={headerTransparent}
            withDrawerMenu={headerWithDrawerMenu}
          />
        )}
        <div className={styles.container} style={containerStyle}>
          <div
            className={cn({
              [styles.innerContainer]: true,
            })}
            style={innerContainerStyle}
          >
            {children}
          </div>
        </div>
        {withFooter ? <Footer /> : null}
      </>
    )
  }
)

AppContainer.displayName = 'AppContainer'
